import { AuthProvider } from '@sportybot-web/auth/provider';
import { MantineProvider } from '@sportybot-web/theme/provider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { domAnimation, LazyMotion } from 'motion/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

async function enableApiMocking() {
  const { worker } = await import('@sportybot-web/mocks/browser');
  await worker.start({ onUnhandledRequest: 'error' });
}

function renderApp() {
  const root = document.getElementById('root');

  if (root) {
    createRoot(root).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <MantineProvider>
            <AuthProvider>
              <LazyMotion features={domAnimation} strict>
                <App />
              </LazyMotion>
            </AuthProvider>
          </MantineProvider>
        </QueryClientProvider>
      </StrictMode>,
    );
  }
}

if (import.meta.env.VITE_API_MOCKING) {
  enableApiMocking().then(renderApp).catch(console.error);
} else {
  renderApp();
}
